import React from 'react';
import PropTypes from 'prop-types';

class OnPageEditing extends React.PureComponent {
    static defaultProps = {
        active: true,
        debug: false,
    }

    static propTypes = {
        active: PropTypes.bool.isRequired,
        children: PropTypes.any,
        component: PropTypes.string,
        debug: PropTypes.bool.isRequired,
        editType: PropTypes.string,
        property: PropTypes.string.isRequired,
    }

    componentDidMount() {
        if(this.props.debug && this.node) {
            this.node.setAttribute('style', 'border: solid 1px #26caff');
        }
    }

    _dataProps() {
        return {
            "ref": node => this.node = node,
            "data-epi-property-name": this.props.property,
            "data-epi-use-mvc": "True",
            "data-epi-property-edittype": this.props.editType || null,
        };
    }

    render() {
        const {
            active,
            children,
            property,
            component,
        } = this.props;

        if(!children) return null;

        if(component) {
            return React.createElement(component, {
                ...this._dataProps()
            }, children);
        }

        if(active && property && !!children) {
            return React.cloneElement(children, {
                ...this._dataProps()
            });
        }

        return children;
    }
}

export default OnPageEditing;



// WEBPACK FOOTER //
// ./src/components/OnPageEditing/OnPageEditing.jsx